import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import {
  HeaderAccordion,
  TableContent,
  IconButtonStyled,
  BallContainer,
} from "../styles/Cliente";
import useClienteController from "../controllers/ClienteController";
import TableDefault from "../../../../components/grid/TableDefault";
import MaskService from "../../../../utils/mask/maskService";
import { ClienteContext } from "../contexts/ClienteContext";
import Chip from "../../../../components/basics/Chip";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import { Check, Clear, DeleteOutlined } from "@material-ui/icons";
import ModalRuralEstablishment from "./ModalRuralEstablishment";

import RedBall from "../../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../../assets/imgs/bolinha-verde.png";

const AccordionRuralEstablishment = () => {
  const {
    listUf,
    listCounty,
    listNation,
    ruralEstablishment,
    setRuralEstablishment,
  } = useContext(ClienteContext);
  const { handleRemoveItemTable, handleEditItemTable } = useClienteController();

  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
    },
    {
      id: "descricao",
      label: "Descrição",
    },
    {
      id: "inscricao_estadual",
      label: "Inscrição Estadual",
    },
    {
      id: "cep",
      label: "CEP",
      align: "center",
      format: (item) => MaskService.toMask("cep", item.endereco?.cep || ""),
    },
    {
      id: "endereco",
      label: "Endereço",
      format: (item) =>
        `${item.endereco?.logradouro || ""}, ${item.endereco?.numero || ""}`,
    },
    {
      id: "complemento",
      label: "Complemento",
      format: (item) => item.endereco?.complemento || "-",
    },
    {
      id: "bairro",
      label: "Bairro",
      format: (item) => item.endereco?.bairro || "-",
    },
    {
      id: "municipio_uf",
      label: "Município-UF",
      format: (item) => {
        const stateAcronym = item.endereco?.estado_id
          ? listUf.find(
              (opt) =>
                opt.id?.toString() === item.endereco?.estado_id?.toString()
            )
          : null;

        const county = item.endereco?.municipio_id
          ? listCounty.find(
              (opt) => opt.codigo === item.endereco?.municipio_id?.toString()
            )
          : null;

        return `${county ? county.municipio : ""} - ${
          stateAcronym ? stateAcronym.estado : ""
        }`;
      },
    },
    {
      id: "pais",
      label: "País",
      format: (item) => {
        const country = listNation.find(
          (opt) => opt.codigo === item.endereco?.pais_id?.toString()
        );
        return country?.descricao || "-";
      },
    },
    {
      id: "contato",
      label: "Contato",
      format: (item) => {
        const ruralContact =
          Array.isArray(item.contatos) && item.contatos[0]
            ? item.contatos[0]
            : null;

        return ruralContact?.infoContato?.nome || "-";
      },
    },
    {
      id: "telefone",
      label: "Telefone",
      format: (item) => {
        const ruralContact =
          Array.isArray(item.contatos) && item.contatos[0]
            ? item.contatos[0]
            : null;

        return MaskService.toMask(
          "cel-phone",
          ruralContact?.infoContato?.telefone || ""
        );
      },
    },
    {
      id: "principal",
      label: "Principal",
      format: (item) =>
        item.principal ? (
          <Check style={{ color: "green" }} />
        ) : (
          <Clear style={{ color: "red" }} />
        ),
    },
    {
      id: "ativo",
      label: "Ativo",
      format: (item) =>
        item.ativo ? (
          <BallContainer>
            <img src={GreenBall} alt="Ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="Inativo" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    (async () => {
      const newList = [];

      ruralEstablishment.forEach((item, index) => {
        item.index = index;

        let rowActions = [
          {
            name: "Editar",
            icon: <EditOutlinedIcon />,
            action: () => handleEditItemTable(setOpen, setRowEdit, item, index),
          },
        ];

        const removeAction = {
          icon: <DeleteOutlined />,
          name: "Excluir",
          action: () =>
            handleRemoveItemTable(
              setRuralEstablishment,
              setDataTable,
              ruralEstablishment,
              index
            ),
        };

        if (!item.principal && !item.id) rowActions.push(removeAction);
        return (newList[index] = {
          ...item,
          acoes: <SpeedDialErp actions={rowActions} />,
        });
      });

      setDataTable(newList);
    })();
  }, [
    ruralEstablishment,
    handleEditItemTable,
    handleRemoveItemTable,
    setRuralEstablishment,
  ]);

  return (
    <>
      {open && (
        <ModalRuralEstablishment
          open={open}
          setOpen={setOpen}
          setRowEdit={setRowEdit}
          rowEdit={rowEdit}
        />
      )}
      <Grid item xs={12}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs>
                  <Chip label="ESTABELECIMENTO RURAL" />
                </Grid>
                <Grid item flex={1}>
                  <Tooltip title="Adicionar Estabelecimento">
                    <IconButtonStyled
                      onClick={(event) => {
                        event.stopPropagation();
                        setOpen(true);
                      }}
                    >
                      <AddIcon />
                    </IconButtonStyled>
                  </Tooltip>
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDefault
                        columns={columns}
                        values={dataTable}
                        tableTitle=""
                      />
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default AccordionRuralEstablishment;
